import React from 'react'
import SimpleHeader from '../../components/UI/header/simpleClientHeader'
import SignedForms from '../../components/business/setting/signedForms'

export default function WaiverFormRedirection(props) {
  const { history } = props
  function toWaiver(step) {
    let url = '/onboarding/waiver?callback=/app/setting'
    if (step) {
      url += `&step=${step}`
    }
    history.push(url)
  }

  function moreForms(type) {
    let step = 'medical'
    switch (type) {
      case 'Medical Release Form':
        step = 'medical'
        break
      case 'Liability Release Form':
        step = 'liabilities'
        break
      case 'Non Disclosure Agreement':
        step = 'nda'
        break
      default:
        break
    }
    history.push(
      `/onboarding/waiver/${step}?callback=/app/setting/view-signed-forms`
    )
  }

  return (
    <div style={{ paddingTop: 200 }}>
      <SimpleHeader history={history} />
      <SignedForms toWaiver={toWaiver} moreForms={moreForms} />
    </div>
  )
}
